<script setup lang="ts">
false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: '/combat-des-circulaires', // -> accessible at /about-us (no prefix since it's the default locale)
    fr: '/combat-des-circulaires', // -> accessible at /fr/a-propos
  },
})
definePageMeta({
  name: 'CombatPage',
})

const config = useRuntimeConfig()

const { data: video, pending, error } = await useFetch(`${config.public.apiUrl}/home/fetch-video`, {

  transform: (response) => {
    // Do anything you want here!
    return response.data
  },
})
</script>

<template>
  <div id="CombatPage">
    <div class="pt-12 overflow-hidden bg-white lg:pt-18">
      <div class="relative max-w-xl px-4 mx-auto sm:px-6 lg:px-8 lg:max-w-5xl w-full">
        <div class="relative">
          <h2 class="text-3xl font-extrabold leading-8 tracking-tight text-center text-poivre-800 sm:text-5xl font-title">
            Le combat des circulaires
          </h2>
          <p class="max-w-4xl mx-auto mt-4 text-xl text-center text-poivre-500">
            Chaque mercredi, en direct sur LCN à 18h30 et en reprise à 22h30 à TVA, on est À vos affaires.
          </p>
        </div>
      </div>
      <div v-if="video" class="flex flex-col justify my-10 lg:max-w-5xl mx-auto">
        <h3 v-if="video.message != ''" class="text-center text-base md:text-lg text-poivre-700 bg-sorbet lg:rounded-t-lg p-2 font-medium">
          <span v-html="video.message" />
        </h3>
        <h3 v-else class="text-center text-base md:text-lg text-poivre-700 bg-sorbet lg:rounded-t-lg p-2 font-medium">
          <span>Édition du {{ video.broadcast_date_formatted }}</span>
        </h3>
        <div class="" style="position:relative;padding-top:56.25%;">
          <iframe :src="`https://iframe.mediadelivery.net/embed/176768/${video.video_id}?autoplay=false&loop=false&muted=false&preload=false`" loading="lazy" style="border:0;position:absolute;top:0;height:100%;width:100%;" allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" allowfullscreen="true" />
        </div>
        <h3 v-if="video.start_date_formatted && video.end_date_formatted" class="text-center text-sm md:text-base text-poivre-700 bg-sorbet lg:rounded-b-lg p-2">
          <span>En vigueur du {{ video.start_date_formatted }} au {{ video.end_date_formatted }}</span>
        </h3>
      </div>
      <div v-else class="py-10">
        <UIcon name="i-mdi-loading" class="w-full mt-1 animate-spin" />
      </div>
      <div class="bg-sel">
        <div class="max-w-8xl mx-auto text-center py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
          <h2 class="text-3xl font-extrabold tracking-tight text-poivre-800 sm:text-4xl font-title">
            <span class="block">Plus de rabais analysés</span>
          </h2>
          <div class="mt-2">
            Le combat des circulaires offre une bonne analyse générale des spéciaux de la semaine, mais tous les spéciaux analysés par Glouton sont disponibles gratuitement dans la sections Circulaires.
          </div>
          <div class="mt-8">
            <UButton size="xl" :to="$localePath({ name: 'FlyersPage' })">
              Ouvrir les circulaires
            </UButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
